module.exports = __webpack_public_path__ + "static/media/ic-shop.d7fc9ca3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ic-shop.svg
// module id = 1958
// module chunks = 0